import { API_CACHE_KEYS } from "api/cacheKeys";
import { useCustomMutation } from "api/useCustomMutation";
import { useCustomQuery } from "api/useCustomQuery";
import { JANZU_URL } from "config/config";
import { ImageQuery } from "types/imageQueries";

import { BaseQueryOptions, CachePolicy } from "../types";

export const useGetImageQuery = (imageQueryId: string, options: BaseQueryOptions<ImageQuery> = {}) =>
  useCustomQuery<ImageQuery>(
    API_CACHE_KEYS.imageQueries.detail(imageQueryId),
    `${JANZU_URL}reef-api/image-queries/${imageQueryId}`,
    {
      cachePolicy: CachePolicy.NO_CACHE,
      enabled: !!imageQueryId,
      ...options,
    }
  );

export const useDeleteImageQuery = () =>
  useCustomMutation<void, string>((id) => `${JANZU_URL}reef-api/image-queries/${id}/delete`, "DELETE", {
    cachePolicy: CachePolicy.NO_CACHE,
  });

export const useImageQuery = (imageQueryId?: string, getOptions: BaseQueryOptions<ImageQuery> = {}) => {
  const deleteImageQueryMutation = useDeleteImageQuery();

  const getImageQueryQuery = useGetImageQuery(imageQueryId || "", {
    enabled: !!imageQueryId,
    ...getOptions,
  });

  return {
    // Get operations
    imageQuery: getImageQueryQuery.data,
    getImageQuery: getImageQueryQuery.refetch,
    isLoadingImageQuery: getImageQueryQuery.isFetching,
    imageQueryError: getImageQueryQuery.error,

    // Delete operations
    deleteImageQuery: deleteImageQueryMutation.mutateAsync,
    isDeleting: deleteImageQueryMutation.isLoading,
    deleteError: deleteImageQueryMutation.error,

    // Combined loading state
    isLoading: deleteImageQueryMutation.isLoading,
  };
};
